var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-review content-padding" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h2", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.reviews.reviews_all")))
          ]),
          _vm._v(" "),
          _c(
            "h2",
            { staticClass: "text-center", staticStyle: { color: "#00ABC2" } },
            [_vm._v(_vm._s(_vm.$t("message.reviews.professional_service")))]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.reviews && _vm.reviews.length > 0
        ? _c(
            "div",
            { ref: "wrap", staticClass: "mb-5 mt-5" },
            [
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.reviews, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index + "_" + item.id,
                      staticClass: "col-12 col-md-6 col-lg-4"
                    },
                    [_c("review-items", { attrs: { item: item } })],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.isMoreContents
                ? _c(
                    "mugen-scroll",
                    {
                      attrs: {
                        handler: _vm.loadMore,
                        "should-handle": !_vm.loading
                      }
                    },
                    [
                      [
                        _c("div", { staticClass: "text-center" }, [
                          _c("img", {
                            attrs: {
                              src: "/static/img/loader.gif",
                              width: "80"
                            }
                          })
                        ])
                      ]
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        : _c("div", [_c("loader")], 1)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47f9f854", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47f9f854","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/review/Reviews.vue
// module id = 2125
// module chunks = 0